import { IComponentController } from 'angular';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IStateParamsService } from 'angular-ui-router';

interface IPageMC2051 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Mc2051Controller(
        Formulaire: IFormulaireClass,
        FormulaireItem: IFormulaireItemClass,
        $stateParams: IStateParamsService
) {
    const vm: IPageMC2051 = this;

    vm.multiOccurrenceOptions = {
        fonctions:{
            rechercheCollapsable: false,
            effaceCriteres: true
        },
        criteresSuggeres: new Formulaire(
            'LBL_RECHERCHE',
            [
                new FormulaireItem('pecann', { 
                    required: true, 
                    default: $stateParams.pecann,
                    readonly: true
                })
            ]
        ),
        colonnesVisibles: [
            { nom: 'fammsg', largeur: 330 }
        ]
    };


}
